export const SHOPURL = {
  CALCULATEPRICE: 'v1/shoppingcart/calculatePrice', // 计算购物车价格
  USERCARTINFO: 'v1/shoppingcart/userCartInfo', // 全局购物车数据
  UPLOADSHOPPINGCARTINFO: 'v1/shoppingcart/uploadShoppingCartInfo', // 同步购物车数据
  SHOPINFO: 'v1/shop/shopInfo', // 获取门店信息
  PRODUCTLIST: 'v1/shop/productList', // 获取商品列表
  /** 商品列表分页 */
  PRODUCTRENDER: 'v1/shop/product/render',
  MULTISKU: 'v1/shop/productSpecifics', //多规格浮层接口
  MULTISKUVALIDATION: 'v1/shop/preCheck', //多规格浮层校验接口
  MULTISKUCALCULATE: 'v1/shop/productPrice', //多规格浮层算价接口
  NEWUSERCOUPONSEND: 'dsp/newuser/coupon/send', // 新客领券（新人大礼包）
  ORDERPRODUCT: 'v1/order/product', // 查询订单菜品
  PICKUPSCANSHOP: 'accurate/v1/event/report/pickupscan', // 自提扫门店码
  /** 凑单商品列表接口 */
  ADDITEMPRODUCTLIST: 'v1/shop/addItemProductList',
  /** 门店搜索 */
  SHOPSEARCHLIST: 'v1/shop/searchProduct',
  /** 门店收藏 */
  ADDFAVORITE: 'v1/userinfo/add_favorite',
  CANCELFAVORETE: 'v1/userinfo/cancel_favorite',
};

export const ERROR_CODE = {
  SHOP_CLOSE: 201003401, // 店铺打烊
  BAN_PROMOTION: 2000003, // 风控 优惠剥夺
  SHOP_OFFLINE: 201003201, // 门店下架
  SHOP_PRODUCT_OFF: 2000011, // 加购商品下架
  CART_MAX_COUNT: 201003701, // 超过购物车最大加购数量
  PICKUP_OFFLINE: 201003223, // 门店自提下线
};

export const SALES_TYPE = {
  CALORIE: -1, //卡路里，前端合并到一起展示
  POINT: -2, //卡路里后边那个小点
  SALES: 0, // 销量类型
  OTHER: 1 // 其它类型，菜品回购类型，菜品排名类型等等
};

export const SCENE_TYPE = {
  PULL: 2, // 拉取全局购物车数据数据
  UPDATA: 3 // 修改购物车数据
};

/** shopinfo接口返回门店状态 */
export const SHOP_STATUS = {
  /** 录入中 */
  SHOP_ENTERING: 1,
  /** 待营业 */
  SHOP_OPEN_SOON: 2,
  /** 营业中 */
  SHOP_OPEN: 3,
  /** 打烊 */
  SHOP_CLOSE: 4,
  /** 已下线 */
  SHOP_OFFLINE: 5,
};

/** 价格计算接口返回门店状态 */
export const SHOP_AVAILABLE = {
  /** 营业中 */
  SHOP_OPEN: 1,
  /** 非营业状态（不可用） */
  SHOP_CLOSE: 0
};

export const MULTI_SKU_ERROR_CODE = {
  ...ERROR_CODE,
  SHOP_REST: 201003202, //店铺打烊
  NO_INVENTORY: 201003203, //无库存
  UNAVAILABLE: 201003212, //未在可售时间
  STYSTEMERROR: 1, //系统异常
  NINE_ONE_NINE_INVALIDATE: 2000018, // 用户不在享受919活动
  NINE_ONE_NINE_OUT_OFF_STOCK: 2000019, // 919活动商品库存不足
  NINE_ONE_NINE_OFFLINE: 2000020, // 919活动已下线
  UN_SELECTED_REQUIRED_PRODUCT: 2000012, // 未选择必选菜
  DISCOUNT_FOOD_SOLD_OUT: 201003221, // 折扣菜售罄
  PREVIEW_PAY_TOTAL_CHANGE: 201003222, // 提单价格变化
};

// 门店页商家列表 快速加购按钮折叠状态
export const ADD_BTN_FOLD_STATUS = {
  EXPAND_START: 1, // 开始展开
  EXPAND_END: 2, // 展开完成
  FOLD_START: 3, // 开始折叠
  FOLD_END: 4, // 折叠完成
};

// 价格接口请求状态
export const CALCULATE_PRICE_STATUS = {
  LOADING: 0, // 请求中
  SUCCESS: 1, // 返回成功
  ERROR: 2, // 返回失败
};
// 多规格接口请求状态
export const PRODUCT_SPEC_STATUS = {
  LOADING: 0, // 请求中
  SUCCESS: 1, // 返回成功
  ERROR: 2, // 返回失败
};
// 门店活动类型
export const SHOP_ACTIVITY_TYPE = {
  /** 折扣菜 */
  DISCOUNT_FOOD: 18,
  /** 满折 */
  FULL_DISCOUNT: 3,
  /** 满减 */
  FULL_REDUCE: 2,
};

// 数据来源 是否展示非折扣商品活动价 source
export const SPU_LIST_SOURCE = {
  SHOP_LIST: 0, // 商品列表
  SHOP_WINDOW: 1, // 商品橱窗
  SHOP_SEARCH: 2, // 门店搜索
};

/** 修改购物车商品的来源 */
export const CHANGE_CART_SOURCE = {
  /** 多规格浮层 */
  MULTI_MODAL: 1,
  /** 门店列表商品卡片 */
  FOOD_LIST: 2,
  /** 购物车浮层 */
  CART_LIST: 3,
  /** 凑单列表浮层 */
  ADD_ITEM_LIST: 4,
};

/** 购物车浮层商品卡片按钮类型 */
export enum ButtonType {
  /** 加 */
  ADD = 0,
  /** 减 */
  DES = 1
}
/** 公共弹窗按钮类型 */
export enum CommonDialogButtonType {
  /** 取消 */
  CANCEL = 0,
  /** 确认 */
  CONFIRM = 1,
}

/** 埋点参数值为空时传入-999 */
export const STATISTICS_NON_VALUE = '-999';
/** 门店商品卡片按钮类型（埋点使用） */
export const PRODUCT_CARD_BTN_TYPE = {
  /** 单规格商品加号 */
  SINGLE_ADD: 1,
  /** 单规格商品减号 */
  SINGLE_DES: 2,
  /** 多规格商品加号 */
  MUTIL_ADD: 3,
};

/** 进入门店预览渠道来源 */
export enum ShopChannel {
  /** 特殊渠道，bd全供给渠道 */
  BD = 'bd',
  /** 特殊渠道，开放平台渠道 */
  OPEN = 'open',
  /** 特殊渠道，商家渠道 */
  MERCHANT = 'merchant',
  /** 特殊渠道，商家管理渠道 */
  PARTNER = 'partner'
}

/** 门店标签 */
export enum ShopLabelTag {
  /** 黄金店铺 */
  SHOPGOLDEN = 'shop_golden',
  /** timeout */
  TIMEOUT = 'tag_timeout',
  /** 米其林 */
  MICHELIN = 'tag_michelin',
}

/** 门店购物车活动条动画状态： start:开始 end:结束 */
export const CART_ACT_ANIM_TYPE = {
  START: 'start',
  END: 'end'
};

/** 是否满足满折门槛 */
export const IS_MEET_SILL_AMOUNT = {
  /** 不满足 */
  0: 0,
  /** 满足 */
  1: 1
};

// 0默认，单列, 1 双列, -100 兜底卡片（1pt高度）
export const SHOP_CATEGORY_TYPE_SINGLE_COLUMN = 0;
export const SHOP_CATEGORY_TYPE_DOUBLE_COLUMN = 1;
export const SHOP_CATEGORY_TYPE_DEFAULT = -100;
export const SHOP_SPU_ID = -1;
// 推荐菜
export const SPU_TYPE_RECOMMAND = 1;
// 折扣菜
export const SPU_TYPE_DISCOUNT = 2;
// 融合菜（是折扣菜也是推荐菜)
export const SPU_TYPE_RECOMMAND_RECOMMAND = 3;

// 用户获取餐品方式
export enum UserGetMode {
  delivery = 'delivery',
  pickup = 'pickup',
}

/** 购物车活动横条按钮类型 */
export enum ACT_TIPS_BAR_TYPE {
  /** 自取更省 */
  PICKUP_SAVE_MONEY = 'PICKUP_SAVE_MONEY',
  /** 凑单*/
  ADD_ITEM = 'ADD_ITEM',
}

// init：页面初始化 login: 登录后请求 switchTab 切换模式tab请求
export enum REQUEST_SCENE {
  init = 'init',
  login = 'login',
  switchTab = 'switchTab',
}

/** 购物车算价场景 */
export enum CALCULATE_PRICE_REQUEST_SCENE {
  switchTab = 'switchTab',
  addCart = 'addCart'
}

export const QRCODE_SCENE = {
  shopPickup: '1', // 自提门店扫码进入
};

/** 分页列表锚点加载状态 */
export enum AnchorFoodListStatus {
  loading,
  success,
  error
}

/** 触发分类列表加载更多类型的场景 */
export enum LoadMoreBottomType {
  /** 锚点切菜品分类Tab */
  anchor,
  /** 上拉加载更多 */
  normal
}
/** 打开多规格浮层（进入门店页scheme带openMultiSku参数） */
export const OPEN_MULTI_SKU = {
  OPEN: '1',
  CLOSE: '0'
};
/**
 * 门店周年庆标签类型
 * 1：门店标签
 * 2：营销标签
 */
export const SHOP_CELEBRATE_TYPE = {
  SHOP_LABEL: 1,
  PROMOTION_LABEL: 2
};

/** 门店头部营销标签类型 */
export const SHOP_PROMOTION_TYPE = {
  /** 1:代表图片 2:代表文字+icon */
  PIC: '1',
  TEXT: '2'
};
/**
 * 门店周年庆标签样式类型
 * 0：普通图片
 * 1：动态标签
 */
export const SHOP_FEATURE_STYLE = {
  NORMAL_PIC: 0,
  DYNAMIC_TAG: 1
};

const safeAreaHeight = Mach.env?.safeAreaInsets?.bottom > 0 ? Mach.env.safeAreaInsets.bottom : 12;
/** 黄金流程购物车bar高度 */
export const CART_BAR_HEIGHT = 58 + safeAreaHeight;
// export const CART_BAR_HEIGHT = 95;
/** 黄金流程购物车bar高度减去圆角的高度10 */
export const CART_BAR_HEIGHT_WITHOUT_RADIUS = 48 + safeAreaHeight;
// export const CART_BAR_HEIGHT_WITHOUT_RADIUS = 85;

// 商品卡片渲染来源
export enum PRODUCT_CARD_RENDER_SOURCE {
  // 商品列表
  PRODUCTT_LIST = 'PRODUCTT_LIST',
  // 商品搜索列表
  PRODUCTT_SEARCH_LIST = 'PRODUCTT_SEARCH_LIST',
}

// 商品卡片上报埋点的卡片类型
export enum LX_REPORT_PRODUCT_CARD_TYPE {
  // 店内商品列表卡片
  PRODUCTT_LIST = 1,
  // 搜索结果卡片
  PRODUCTT_SEARCH_LIST = 2,
  // 商品橱窗卡片
  SHOP_WINDOW_LIST = 3,
}

/** 门店指标转化率 */
export const SHOP_INDICATOR_CONVER_RATE = {
  /** 页面PV */
  PV: 1,
  /** 加购 */
  ADD_CART: 2,
  /** 提单 */
  CHECK_OUT: 3
};

/** 门店搜索结果状态 */
export const SHOP_SEARCH_STATUS = {
  /** 搜索有值 */
  SUCCESS: 1,
  /** 搜索无结果 */
  NULL: 0,
};

/** 购物车展开成功率（排除BD包） */
export const SHOP_CART_SHOW = {
  /** 购物车请求 */
  DEFAULT: 1,
  /** 购物车请求失败  */
  REQ_ERROR: 2,
  /** 购物车请求返回结果为空  */
  REQ_RESULT_NULL: 3,
  /** 购物车展开成功 */
  CART_SHOW: 4,
};

export const SHOP_REGION = {
  SA: 'SA',
  HK: 'HK'
};

// 低消弹窗类型
export enum MIN_ORDER_POP_TYPE {
  /** 非导流补差价场景 */
  NO_DIVERSION = 0,
  /** 导流补差价场景（可切换自取） */
  DIVERSION = 2,
}

/**
 * 低消弹窗-自取导流按钮类型
 *  1. 切自取提单
 *  2. 不切自取直接提单
 */
export enum MIN_ORDER_POP_BTN_TYPE {
  /** 切自取提单 */
  SWITCH_TO_PICKUP = 1,
  /** 不切自取直接提单 */
  CONTINUE_WITHOUT_PICKUP = 2,
}

/** 黄金链路bundleVersion修改 */
export const BundleVersion = Mach.env.bundleVersion === '0.0.1' ? '0.1.999' : Mach.env.bundleVersion;
